import PropTypes from "prop-types"
import React from "react"
import { Link, useStaticQuery } from "gatsby"

import "../css/gov-info.css"

import { HandleImages } from "./functions"
import Img from "gatsby-image"
import bike from "../images/bike.webm"
import door from "../images/door.webm"
import OnVisible from "react-on-visible"

import pAIcon from "../images/project-ares-logo.svg"
import arrow from "../images/arrow.webm"
import student from "../images/student.webm"

import map from "../images/map.webm"
const style = {}
var height
var position

class GovInfo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: true,
      active: true,
    }
  }

  componentDidMount() {
    var current = this
    console.log("mount", this.state.active)
    this.setState({
        safari:!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)
    })
    /* setInterval(function() {
        current.setState({
          active: !current.state.active
        });
      }, 5000)*/
  }

  render() {
    return (
      <div className="gov-info-wrapper">
        <div className="pre-top">
          <div>
            <h3><span>Volatile economic times</span> + <span>Social unrest</span> + <span>Uncertainty</span></h3>
            <h3>A trifecta of ingredients ripe for cyber adversaries to leverage for attacks.</h3>
            <HandleImages name="chart" />
          </div>
          <div>
            <h4>
           Without proper training in place, federal and regional cyber warrior cannot <span>protect the digital and physical spaces</span> that businesses and civilians rely on as vehicels of <span>connection and commerce</span>
            </h4> <HandleImages name="bubble" />
          </div>
        </div>
 

        <div className="bottom">
          <div className="left">
            <div>
              <img alt="Project Ares Logo" src={pAIcon} />
              <p>
                Use training budgets wisely. Practive cyber security skills when it's convenient for you!
              </p>
            </div>
            <HandleImages name="gov" />
          </div>
          <div className="right">
            <div>
              <p>An investment in hands-on cyber range training</p>

              <ul>
                <li><svg   x="0px" y="0px"   viewBox="0 0 46.9 38.9" >
 
 <g>
     <g>
         <path class="st0" d="M34.4,17c-0.3,0-0.5-0.2-0.5-0.5V10h-4V6H17v4h-4v6.5c0,0.3-0.2,0.5-0.5,0.5S12,16.7,12,16.5V9h4V5h15v4h4
             v7.5C34.9,16.7,34.7,17,34.4,17z"/>
     </g>
     <g>
         <path class="st0" d="M27.4,6c-0.3,0-0.5-0.2-0.5-0.5V1h-7v4.5C20,5.8,19.7,6,19.5,6S19,5.8,19,5.5V0h9v5.5C27.9,5.8,27.7,6,27.4,6
             z"/>
     </g>
     <g>
         <path class="st0" d="M11.5,31.9c-0.2,0-0.4-0.1-0.4-0.3c-0.2-0.3-4.2-8.1-5-11.4l-0.1-0.4l0.3-0.2c0.4-0.3,10.7-6.5,17.1-7.7
             l0.1,0l0.1,0c6.4,1.2,16.7,7.4,17.1,7.7l0.3,0.2l-0.1,0.4c-0.8,3.3-4.9,11.1-5,11.4c-0.1,0.2-0.4,0.3-0.7,0.2
             c-0.2-0.1-0.3-0.4-0.2-0.7c0-0.1,3.9-7.4,4.9-10.9C38,19.3,29.1,14.1,23.4,13c-5.6,1.1-14.6,6.3-16.4,7.3c1,3.4,4.8,10.8,4.9,10.9
             c0.1,0.2,0,0.5-0.2,0.7C11.6,31.9,11.6,31.9,11.5,31.9z"/>
     </g>
     <g>
         <path class="st0" d="M0.5,33.5c-0.2,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.1-0.5,0.1-0.7L4,30.2c1-0.7,2.4-0.6,3.3,0.2l1.4,1.2
             c0.6,0.5,1.5,0.6,2.1,0.1l2.1-1.4c1-0.7,2.3-0.6,3.3,0.1l1.6,1.3c0.6,0.5,1.5,0.5,2.1,0l1.9-1.4c1-0.7,2.3-0.7,3.3,0l1.8,1.3
             c0.6,0.5,1.5,0.5,2.1,0l1.7-1.3c1-0.7,2.3-0.8,3.3-0.1l2,1.4c0.6,0.5,1.5,0.4,2.1-0.1l1.5-1.2c1-0.8,2.3-0.8,3.3-0.1l3.6,2.4
             c0.2,0.2,0.3,0.5,0.1,0.7c-0.2,0.2-0.5,0.3-0.7,0.1L42.5,31c-0.7-0.4-1.5-0.4-2.1,0.1l-1.5,1.2c-1,0.8-2.3,0.8-3.4,0.1l-2-1.4
             c-0.6-0.5-1.5-0.4-2.1,0l-1.7,1.3c-1,0.7-2.4,0.8-3.3,0l-1.8-1.3c-0.6-0.5-1.5-0.5-2.1,0l-1.9,1.4c-1,0.7-2.4,0.7-3.3-0.1
             l-1.6-1.3c-0.6-0.5-1.5-0.5-2.1-0.1l-2.1,1.4c-1,0.7-2.4,0.6-3.4-0.2l-1.4-1.2C6,30.6,5.2,30.6,4.5,31l-3.7,2.4
             C0.7,33.5,0.6,33.5,0.5,33.5z"/>
     </g>
     <g>
         <path class="st0" d="M0.5,38.9c-0.2,0-0.3-0.1-0.4-0.2C-0.1,38.5,0,38.1,0.2,38L4,35.5c1-0.7,2.4-0.6,3.3,0.2l1.4,1.2
             c0.6,0.5,1.5,0.6,2.1,0.1l2.1-1.4c1-0.7,2.3-0.6,3.3,0.1l1.6,1.3c0.6,0.5,1.5,0.5,2.1,0l1.9-1.4c1-0.7,2.3-0.7,3.3,0L27,37
             c0.6,0.5,1.5,0.5,2.1,0l1.7-1.3c1-0.7,2.3-0.8,3.3-0.1l2,1.4c0.6,0.5,1.5,0.4,2.1-0.1l1.5-1.2c1-0.8,2.3-0.8,3.3-0.1l3.6,2.4
             c0.2,0.2,0.3,0.5,0.1,0.7c-0.2,0.2-0.5,0.3-0.7,0.1l-3.6-2.4C41.8,36,41,36,40.4,36.5l-1.5,1.2c-1,0.8-2.3,0.8-3.4,0.1l-2-1.4
             c-0.6-0.5-1.5-0.4-2.1,0l-1.7,1.3c-1,0.8-2.4,0.8-3.3,0l-1.8-1.3c-0.6-0.5-1.5-0.5-2.1,0l-1.9,1.4c-1,0.7-2.4,0.7-3.3-0.1
             l-1.6-1.3C15,36,14.1,36,13.5,36.4l-2.1,1.4c-1,0.7-2.4,0.6-3.4-0.2l-1.4-1.2C6,36,5.2,35.9,4.5,36.4l-3.7,2.4
             C0.7,38.9,0.6,38.9,0.5,38.9z"/>
     </g>
     <g>
         <path class="st0" d="M23.4,27.9c-0.3,0-0.5-0.2-0.5-0.5v-15c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v15
             C23.9,27.7,23.7,27.9,23.4,27.9z"/>
     </g>
     <g>
         <path class="st0" d="M18.9,21c-0.3,0-0.5-0.2-0.5-0.5v-2c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v2C19.4,20.7,19.2,21,18.9,21z"/>
     </g>
     <g>
         <path class="st0" d="M27.9,21c-0.3,0-0.5-0.2-0.5-0.5v-2c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v2C28.4,20.7,28.2,21,27.9,21z"/>
     </g>
 </g>
 </svg>
                  <span>Improves cyber warfighting </span> &nbsp; and operations for air, land, and
                  sea
                </li>
                <li>
                <span> 
<svg version="1.1"  x="0px" y="0px"  viewBox="0 0 37.3 40.3" >
 
<g>
    <path class="st0" d="M32.4,7.7c1.4,0.8,2.5,1.9,3.3,3.3c0.9-1.1,0.9-2.2-0.1-3.2C34.6,6.9,33.6,6.9,32.4,7.7 M18.9,21.2
        c1.4,0.7,2.5,1.8,3.3,3.3L35,11.7c-0.7-1.4-1.8-2.5-3.3-3.3L18.9,21.2z M17.9,26.2l0.1,0.1l3.3-1.2c-0.7-1.4-1.7-2.4-3-3l-1.2,3.3
        l0.1,0.1L17.9,26.2z M16,27.9c-0.1,0-0.3-0.1-0.4-0.1c-0.2-0.2-0.2-0.4-0.1-0.6l0.7-1.2l-0.1-0.1c-0.1-0.1-0.2-0.3-0.1-0.5l1.5-4.1
        c0,0,0,0,0,0v0c0,0,0,0,0,0c0,0,0,0,0,0c0-0.1,0.1-0.1,0.1-0.2L31.2,7.5c0,0,0,0,0,0L31.7,7c0,0,0,0,0,0c1.6-1.2,3.2-1.2,4.6,0.1
        c0,0,0,0,0,0c1.3,1.5,1.3,3.1,0,4.6c0,0,0,0,0,0l-0.5,0.4c0,0,0,0,0,0L22.4,25.7c0,0-0.1,0.1-0.2,0.1c0,0,0,0,0,0c0,0,0,0,0,0l0,0
        c0,0,0,0,0,0l-4.1,1.5c-0.2,0.1-0.4,0-0.5-0.1l-0.1-0.1l-1.2,0.7C16.2,27.9,16.1,27.9,16,27.9"/>
</g>
<g>
    <path class="st0" d="M7.1,6.5h16V3.2h-2.2c-0.1,0-0.2,0-0.3-0.1C19,1.7,17.2,1,15.1,1C13,1,11.2,1.7,9.7,3.1
        C9.6,3.2,9.5,3.2,9.3,3.2H7.1V6.5z M29.7,40.3H0.5C0.2,40.3,0,40,0,39.8v-36c0-0.3,0.2-0.5,0.5-0.5h5.6V2.7c0-0.3,0.2-0.5,0.5-0.5
        h2.5C10.8,0.7,12.8,0,15.1,0c2.3,0,4.3,0.7,6,2.2h2.5c0.3,0,0.5,0.2,0.5,0.5v0.5h5.6c0.3,0,0.5,0.2,0.5,0.5V7
        c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5V4.2h-5.1V7c0,0.3-0.2,0.5-0.5,0.5h-17C6.3,7.5,6.1,7.3,6.1,7V4.2H1v35h28.2V17.9
        c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v21.9C30.2,40,30,40.3,29.7,40.3"/>
</g>
<g>
    <path class="st0" d="M27.1,10.1c-0.2,0-0.4-0.2-0.4-0.4v-4h-3.2c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h3.5
        c0.2,0,0.4,0.2,0.4,0.4v4.3C27.5,10,27.3,10.1,27.1,10.1 M22.7,32v3.5l3.5-3.5H22.7z M22.4,36.7H3.1c-0.2,0-0.4-0.2-0.4-0.4V5.4
        c0-0.2,0.2-0.4,0.4-0.4h3.5C6.8,5.1,7,5.2,7,5.4c0,0.2-0.2,0.4-0.4,0.4H3.4V36H22v-4.4c0-0.2,0.2-0.4,0.4-0.4h4.4V20.5
        c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4v11.1v0c0,0.1,0,0.2-0.1,0.3l-4.7,4.7C22.6,36.7,22.5,36.7,22.4,36.7L22.4,36.7z"/>
</g>
<g>
    <g>
        <path class="st0" d="M12.1,25.2H5.9c-0.2,0-0.3-0.1-0.3-0.3v-5.7c0-0.2,0.1-0.3,0.3-0.3h4.7v0.7H6.2v5.1h5.6v-2.3h0.7v2.6
            C12.5,25,12.3,25.2,12.1,25.2z"/>
    </g>
    <g>
        <path class="st0" d="M9,23.6c-0.1,0-0.2,0-0.2-0.1l-1.6-1.6l0.5-0.5L9,22.8l3.4-3.9l0.5,0.4l-3.7,4.2C9.2,23.5,9.1,23.6,9,23.6
            C9,23.6,9,23.6,9,23.6z"/>
    </g>
    <g>
        <path class="st0" d="M12.1,33.5H5.9c-0.2,0-0.3-0.1-0.3-0.3v-5.7c0-0.2,0.1-0.3,0.3-0.3h4.7v0.7H6.2v5.1h5.6v-2.3h0.7v2.6
            C12.5,33.4,12.3,33.5,12.1,33.5z"/>
    </g>
    <g>
        <path class="st0" d="M9,31.9c-0.1,0-0.2,0-0.2-0.1l-1.6-1.6l0.5-0.5L9,31.1l3.4-3.9l0.5,0.4l-3.7,4.2C9.2,31.9,9.1,31.9,9,31.9
            C9,31.9,9,31.9,9,31.9z"/>
    </g>
    <g>
        <path class="st0" d="M12.1,16.8H5.9c-0.2,0-0.3-0.1-0.3-0.3v-5.7c0-0.2,0.1-0.3,0.3-0.3h4.7v0.7H6.2v5.1h5.6v-2.3h0.7v2.6
            C12.5,16.7,12.3,16.8,12.1,16.8z"/>
    </g>
    <g>
        <path class="st0" d="M9,15.2c-0.1,0-0.2,0-0.2-0.1l-1.6-1.6l0.5-0.5L9,14.4l3.4-3.9l0.5,0.4l-3.7,4.2C9.2,15.2,9.1,15.2,9,15.2
            C9,15.2,9,15.2,9,15.2z"/>
    </g>
</g>
</svg>Exceeds cyber readiness</span>&nbsp; standards and meets stringent policies  

                </li>
                <li>
                <span><svg  x="0px" y="0px" width="42.7px"
     height="42.7px" viewBox="0 0 42.7 42.7" >
 
<g>
    <path class="st0" d="M35,27.2c-0.1-0.1-0.2-0.2-0.4-0.2h-6.9L15,14.2c-0.1-0.1-0.2-0.2-0.4-0.2s-0.3,0.1-0.4,0.2
        c-0.1,0.1-0.2,0.2-0.2,0.4c0,0.1,0.1,0.3,0.2,0.4L27,27.8v6.9c0,0.1,0.1,0.3,0.2,0.4l7.5,7.5c0.2,0.2,0.4,0.2,0.6,0.1
        c0.2-0.1,0.3-0.3,0.3-0.5v-6.5h6.5c0.2,0,0.4-0.1,0.5-0.3c0.1-0.2,0-0.4-0.1-0.6L35,27.2z M34.5,40.8l-6.4-6.4v-5.5l6.4,6.4V40.8z
         M35.3,34.5l-6.4-6.4h5.5l6.4,6.4H35.3z"/>
    <path class="st0" d="M22.3,25.8c-0.1,0-0.3,0-0.4,0.1c-2.2,1.4-4.7,2.2-7.3,2.2c-7.4,0-13.5-6-13.5-13.5c0-7.4,6-13.5,13.5-13.5
        c7.4,0,13.5,6,13.5,13.5c0,2.6-0.7,5.1-2.2,7.3c-0.2,0.3-0.1,0.6,0.2,0.8c0.3,0.2,0.6,0.1,0.8-0.2c1.5-2.4,2.3-5.1,2.3-7.9
        c0-8-6.5-14.6-14.6-14.6C6.5,0,0,6.5,0,14.6c0,8,6.5,14.6,14.6,14.6c2.8,0,5.5-0.8,7.9-2.3h0c0.1-0.1,0.2-0.2,0.2-0.4
        c0-0.1,0-0.3-0.1-0.4C22.6,26,22.5,25.9,22.3,25.8z"/>
    <path class="st0" d="M22.7,19.3c0.3,0.1,0.6,0,0.7-0.2c0.7-1.4,1.1-2.9,1.1-4.4c0-5.5-4.5-9.9-9.9-9.9c-5.5,0-9.9,4.5-9.9,9.9
        c0,5.5,4.5,9.9,9.9,9.9c1.5,0,3-0.4,4.4-1.1c0.3-0.1,0.4-0.5,0.2-0.7c-0.1-0.3-0.5-0.4-0.7-0.2c-1.2,0.6-2.6,0.9-3.9,0.9
        c-4.9,0-8.8-4-8.8-8.8c0-4.9,4-8.8,8.8-8.8s8.8,4,8.8,8.8c0,1.4-0.3,2.7-0.9,3.9C22.3,18.8,22.5,19.1,22.7,19.3z"/>
    <path class="st0" d="M18.7,15c0,0.1,0,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.4,0.2l0,0c0.2,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.2,0.2-0.4
        c0-0.2,0-0.4,0-0.5c0-2.9-2.4-5.3-5.3-5.3c-2.9,0-5.3,2.4-5.3,5.3c0,2.9,2.4,5.3,5.3,5.3c0.2,0,0.4,0,0.5,0c0.1,0,0.3-0.1,0.4-0.2
        c0.1-0.1,0.1-0.3,0.1-0.4c0-0.3-0.3-0.5-0.6-0.5c-0.1,0-0.3,0-0.4,0c-2.3,0-4.2-1.9-4.2-4.2c0-2.3,1.9-4.2,4.2-4.2
        c2.3,0,4.2,1.9,4.2,4.2C18.7,14.7,18.7,14.9,18.7,15z"/>
</g>
</svg> Modernizes lethal forces</span>&nbsp; to deepen interoperability 

                </li>
                <li>
                <span><svg x="0px" y="0px" width="36.6px"      height="37.2px" viewBox="0 0 36.6 37.2"  > <path class="st0" d="M36,35.9h-6.5V17.4l0,0l3.1-2.4l-0.3,1.9c0,0.2,0,0.3,0.1,0.5c0.1,0.1,0.2,0.2,0.4,0.2c0.3,0.1,0.7-0.2,0.7-0.5     l0.5-3.5c0,0,0-0.1,0-0.1l0-0.2c0-0.1,0-0.1-0.1-0.2h-0.1v-0.1c-0.1-0.1-0.2-0.1-0.3-0.2c0,0,0,0-0.1,0l-0.1,0l-3.3-0.3     c-0.3,0-0.6,0.2-0.7,0.6c0,0.2,0,0.3,0.1,0.5c0.1,0.1,0.3,0.2,0.4,0.2l1.7,0.2l-0.2,0.2L18.9,24l-0.1-0.1l-4.7-5     c-0.2-0.2-0.6-0.3-0.8-0.1l-12,9.3V0.6C1.3,0.3,1,0,0.6,0S0,0.3,0,0.6v35.9c0,0.3,0.3,0.6,0.6,0.6H36c0.3,0,0.6-0.3,0.6-0.6     S36.3,35.9,36,35.9z M4.6,35.9H1.3v-6.3l0,0l3.3-2.5V35.9z M10.5,35.9H5.8v-9.8l0,0l4.6-3.6V35.9z M16.4,35.9h-4.6V21.6l0,0l1.8-1.4     l2.8,3V35.9z M22.3,35.9h-4.6V24.5l0.7,0.8c0.2,0.2,0.6,0.3,0.8,0.1l3.1-2.4V35.9z M28.2,35.9h-4.6V22l0,0l4.6-3.6V35.9z"/> </svg> Develops greater performance and accountability</span>&nbsp; among professionals

                </li>
                <li>
                <span><svg x="0px" y="0px" width="32.7px"
     height="43.9px" viewBox="0 0 32.7 43.9">
<path class="st0" d="M29.3,16.9L29,16.8v-4.1C29,5.7,23.3,0,16.4,0S3.7,5.7,3.7,12.6v4.1l-0.3,0.1c-2,0.5-3.4,2.2-3.4,4.3v18.3
    c0,2.4,2,4.4,4.4,4.4h23.9c2.4,0,4.4-2,4.4-4.4V21.2C32.7,19.1,31.3,17.3,29.3,16.9z M4.8,12.6C4.8,6.3,10,1.1,16.4,1.1
    s11.5,5.2,11.5,11.5v4.1h-2.6v-4.1c0-4.9-4-8.9-8.9-8.9s-8.9,4-8.9,8.9v4.1H4.8V12.6z M24.2,12.6v4.1H8.5v-4.1
    c0-4.3,3.5-7.8,7.8-7.8S24.2,8.3,24.2,12.6z M31.6,39.5c0,1.8-1.5,3.3-3.3,3.3H4.4c-1.8,0-3.3-1.5-3.3-3.3V21.2
    c0-1.8,1.5-3.3,3.3-3.3h23.9c1.8,0,3.3,1.5,3.3,3.3V39.5z"/>
<path class="st0" d="M16.4,24.2c-2.4,0-4.3,1.9-4.3,4.3c0,0.7,0.3,1.5,0.8,2l1,1V34c0,1.3,1.1,2.4,2.4,2.4s2.4-1.1,2.4-2.4v-2.6l1-1
    c0.5-0.5,0.8-1.2,0.8-2C20.6,26.1,18.7,24.2,16.4,24.2z M19,29.6L17.7,31v3c0,0.7-0.6,1.3-1.3,1.3s-1.3-0.6-1.3-1.3v-3l-1.4-1.4
    c-0.3-0.3-0.5-0.8-0.5-1.2c0-1.7,1.4-3.2,3.2-3.2s3.2,1.4,3.2,3.2C19.5,28.9,19.3,29.3,19,29.6z"/>
</svg> Ensures a secure cyber environment</span>&nbsp; for all communities and groups 
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="map">
        <div className="left">
          <div>
          <h3><svg x="0px" y="0px" width="50.1px"     height="50.1px" viewBox="0 0 50.1 50.1" >
<g>
    <g>
        <path class="st0" d="M43.7,20.1c0,12-6.6,23-17.2,28.7c-3.1-1.7-5.9-3.8-8.2-6.2c0,0.1-0.1,0.1-0.1,0.2l-0.5,0.5
            c2.5,2.6,5.4,4.8,8.6,6.5c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1c11-5.8,17.9-17.1,17.9-29.6c0-2.2-0.2-4.4-0.6-6.5l-0.8,0.8
            C43.5,16.2,43.7,18.1,43.7,20.1z"/>
        <path class="st0" d="M9.3,20.1c0-3,0.4-6.1,1.2-8.9c3.5-0.2,6.3-2.9,6.5-6.4c3.1,0.3,6.3,0.4,9.4,0.4c3.1,0,6.3-0.1,9.4-0.4
            c0,0.6,0.2,1.1,0.3,1.6L37,5.6c-0.1-0.4-0.2-0.9-0.2-1.4c0-0.1-0.1-0.3-0.2-0.3c-0.1-0.1-0.2-0.1-0.4-0.1C33,4,29.7,4.2,26.5,4.2
            c-3.2,0-6.5-0.2-9.8-0.5c-0.1,0-0.3,0-0.4,0.1c-0.1,0.1-0.2,0.2-0.2,0.3c0,3.3-2.7,6-6,6c-0.2,0-0.4,0.1-0.5,0.3
            c-0.9,3.1-1.4,6.3-1.4,9.5c0,4.2,0.8,8.2,2.2,11.9l0.7-0.7C10,27.7,9.3,24,9.3,20.1z"/>
        <path class="st0" d="M12.9,20.1c0-2.1,0.2-4.1,0.7-6.1c0.1-0.3-0.1-0.5-0.4-0.6c-0.3-0.1-0.5,0.1-0.6,0.4
            c-0.4,2.1-0.7,4.2-0.7,6.3c0,3.2,0.5,6.2,1.4,9.1l0.8-0.8C13.3,25.8,12.9,22.9,12.9,20.1z"/>
        <path class="st0" d="M26.2,45.5c0.1,0,0.2,0.1,0.2,0.1c0.2,0,0.3-0.1,0.4-0.2c0.1-0.2,0.1-0.5-0.2-0.6c-2.9-1.8-5.4-4-7.4-6.5
            l-0.7,0.7C20.7,41.5,23.3,43.7,26.2,45.5z"/>
    </g>
    <g>
        <g>
            <path class="st0" d="M6.3,47.8l-4-4c-0.2-0.2-0.2-0.5,0-0.7l6.2-6.2c0.2-0.2,0.5-0.2,0.7,0l4,4c0.2,0.2,0.2,0.5,0,0.7L7,47.8
                C6.8,48,6.5,48,6.3,47.8z M3.3,43.4l3.3,3.3l5.5-5.5l-3.3-3.3L3.3,43.4z"/>
        </g>
        <g>
            <path class="st0" d="M14.9,44l-8.8-8.8c-0.2-0.2-0.2-0.5,0-0.7l2-2c0.2-0.2,0.5-0.2,0.7,0l8.8,8.8c0.2,0.2,0.2,0.5,0,0.7l-2,2
                C15.4,44.2,15.1,44.2,14.9,44z M7.1,34.8l8.1,8.1l1.3-1.3l-8.1-8.1L7.1,34.8z"/>
        </g>
        <g>
            <path class="st0" d="M4.1,49.5L0.5,46c-0.7-0.7-0.7-1.9,0-2.6c0.7-0.7,1.9-0.7,2.7,0l3.6,3.6c0.7,0.7,0.7,1.9,0,2.6
                C6,50.3,4.8,50.3,4.1,49.5z M2.5,44c-0.4-0.4-0.9-0.4-1.3,0c-0.4,0.4-0.4,1,0,1.3l3.6,3.6c0.4,0.4,0.9,0.4,1.3,0
                c0.4-0.4,0.4-1,0-1.3L2.5,44z"/>
        </g>
        <g>
            <path class="st0" d="M15.3,40.3l-5.5-5.5c-0.2-0.2-0.2-0.5,0-0.7L42.5,1.4c0.1-0.1,0.2-0.1,0.2-0.1L49.5,0
                c0.3-0.1,0.6,0.2,0.5,0.5l-1.2,6.7c0,0.1-0.1,0.2-0.1,0.2L15.9,40.3C15.8,40.5,15.5,40.5,15.3,40.3z M10.7,34.5l4.9,4.9L48,7
                L49,1.1l-5.9,1.1L10.7,34.5z"/>
        </g>
        <g>
            <path class="st0" d="M12.5,37.6c-0.2-0.2-0.2-0.5,0-0.7L44.9,4.6c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7L13.2,37.6
                C13,37.8,12.7,37.8,12.5,37.6z"/>
        </g>
        <g>
            <g>
                <path class="st0" d="M10.4,43.6l-4-4c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0l4,4c0.2,0.2,0.2,0.5,0,0.7
                    C10.9,43.8,10.6,43.8,10.4,43.6z"/>
            </g>
            <g>
                <path class="st0" d="M8.4,45.7l-4-4c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l4,4c0.2,0.2,0.2,0.5,0,0.7S8.6,45.9,8.4,45.7z"/>
            </g>
        </g>
    </g>
</g>
</svg>Regional Cyber Forces</h3>
          <ul>
            <li>More than <span>104 ransomware</span> attacks targeted state and local government agencies</li>
            <li><span>Only 38% of respondents</span> working for state and local governments said they had received training, leaving a great deal of room for improvement.</li>
          </ul></div>

          <div>
          <h3><svg x="0px" y="0px" width="86.4px"     height="38.1px" viewBox="0 0 86.4 38.1" >
<g>
    <g>
        <path class="st0" d="M77.1,10.8c-1.9,0-4.5-0.3-7.9-0.9c-3.6-0.6-6.8-1.4-7.4-1.6c-0.2-0.1-0.4-0.3-0.3-0.5
            c0.1-0.2,0.3-0.3,0.5-0.3c0,0,0,0,0,0c0.6,0.1,3.8,0.9,7.4,1.6c6.5,1.2,9.1,1,10.1,0.6c2.1-0.8,3.9-2.2,5.1-4.2
            c0.9-1.5,1.1-2.8,1.1-2.8c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.1-0.2-0.1H56.6c-0.1,0-0.2,0.1-0.2,0.2c0,0.2-1.2,4.5-4.3,6.5
            c-0.6,0.4-1.3,0.7-2,0.8c-0.7,0.1-1.3,0-1.6,0l-0.2-0.1l-0.4-1.3c0-0.1-0.8-3.1-0.9-3.6l0-0.2l0.1-0.1c0.5-0.7,2.2-1.2,3.6-1
            c0-0.5-0.2-0.9-0.5-1.2c-0.4-0.5-1.3-0.8-2.4-0.8l-0.1,0c-2.6-1-5.5-1.1-7.7-0.2c-0.1,0.5-0.2,1.1-0.3,1.7
            c-0.1,0.6-0.1,1.2-0.3,1.8c0,0.3-0.3,1.7-0.9,3.6l-0.4,1c-0.3,0.4-1.1,0.6-2,0.4c-0.8-0.2-1.4-0.5-2-0.9c-3-1.9-4.2-6.3-4.3-6.5
            c0-0.1-0.1-0.2-0.2-0.2H1c-0.1,0-0.1,0-0.2,0.1c0,0.1-0.1,0.1,0,0.2C0.8,2.8,1,4,1.9,5.5c1.2,2,2.9,3.4,5.1,4.2
            c1,0.4,3.6,0.5,10.1-0.6c3.5-0.6,6.7-1.4,7.4-1.6l0.2,0.8c-0.6,0.2-3.8,0.9-7.4,1.6c-5.4,1-8.9,1.2-10.5,0.6
            C4.4,9.6,2.5,8.1,1.2,5.9C0.3,4.3,0,3,0,2.8C0,2.5,0,2.2,0.2,2C0.4,1.8,0.7,1.6,1,1.6h28.7c0.5,0,0.9,0.3,1,0.8c0,0,1.1,4.2,3.9,6
            c0.5,0.3,1.1,0.6,1.8,0.8c0.6,0.1,1,0,1.1,0l0.3-0.8c0.5-1.9,0.8-3.3,0.8-3.5C38.8,4.1,38.9,3.5,39,3c0.1-0.7,0.2-1.4,0.3-2
            l0.1-0.2l0.2-0.1c2.5-1,5.6-1,8.4,0.1c1.3,0.1,2.3,0.4,2.9,1.1c0.5,0.5,0.7,1.3,0.7,2.2l0,0.5l-0.5-0.1c-1.3-0.3-2.7,0.1-3.2,0.5
            c0.2,0.9,0.8,3.3,0.8,3.4l0.3,0.8c0.2,0,0.6,0.1,1,0c0.7-0.2,1.2-0.4,1.8-0.7c2.8-1.7,3.9-5.9,3.9-6c0.1-0.5,0.5-0.8,1-0.8h28.7
            c0.3,0,0.6,0.1,0.8,0.4c0.2,0.2,0.3,0.5,0.2,0.8c0,0-0.2,1.4-1.2,3.1c-1.3,2.1-3.2,3.7-5.5,4.5C79.1,10.7,78.2,10.8,77.1,10.8z"/>
    </g>
    <g>
        <path class="st1" d="M43.2,1.3c1.4,0,3.2,0.3,4,0.7c-0.3,0.4-0.8,0.6-1.3,0.5C44.9,2.4,44.5,1.9,43.2,1.3L43.2,1.3z"/>
    </g>
    <g>
        <path class="st0" d="M43.2,38.1l-0.3-0.5c-4.6-6.4-7.2-7.6-8.5-8.2c-1.4-0.6-1.3-1-0.5-3.5c0.3-0.9,0.7-2.1,1.2-3.7
            c0.1-0.2,0.3-0.3,0.5-0.3c0.2,0.1,0.3,0.3,0.3,0.5c-0.5,1.6-0.9,2.8-1.2,3.7c-0.7,2.1-0.7,2.1,0.1,2.5c1.3,0.6,4,1.8,8.5,8
            c4.5-6.2,7.2-7.4,8.5-8c0.8-0.4,0.8-0.4,0.1-2.5c-0.3-0.9-0.7-2.1-1.2-3.7c-0.1-0.2,0.1-0.4,0.3-0.5c0.2-0.1,0.4,0.1,0.5,0.3
            c0.5,1.6,0.9,2.8,1.2,3.7c0.8,2.5,0.9,2.8-0.5,3.5c-1.3,0.6-3.9,1.8-8.5,8.2L43.2,38.1z"/>
    </g>
    <g>
        <path class="st0" d="M15.8,14.6c-0.3,0-0.6,0-0.9-0.1c-3.2-0.5-6.3-3.9-6.3-3.9c-0.1-0.2-0.1-0.4,0-0.6c0.2-0.1,0.4-0.1,0.6,0
            c0,0,2.9,3.3,5.8,3.7c4,0.6,12.1-3.9,12.4-4c0.2-0.1,0.4,0,0.5,0.2s0,0.4-0.2,0.5C27.5,10.6,20.2,14.6,15.8,14.6z"/>
    </g>
    <g>
        <path class="st0" d="M21.1,17.7c-1.5,0-2.8-0.6-4-1.8c-0.8-0.8-1.1-1.4-1.1-1.5c-0.1-0.2,0-0.4,0.2-0.5c0.2-0.1,0.4,0,0.5,0.2
            c0,0,0.2,0.5,1,1.3c1,1,2.2,1.6,3.4,1.6c1.3,0,3.3-0.8,5.7-2.4c1.8-1.2,3.2-2.4,3.2-2.4c0.2-0.1,0.4-0.1,0.6,0
            c0.1,0.2,0.1,0.4,0,0.6c0,0-1.4,1.2-3.3,2.5C24.6,16.9,22.6,17.7,21.1,17.7z"/>
    </g>
    <g>
        <path class="st0" d="M26.5,19.8l-0.1,0c-1.3-0.1-2.5-0.6-3.3-1.6c-0.5-0.6-0.6-0.9-0.7-1c-0.1-0.2,0.1-0.4,0.3-0.5
            c0.2-0.1,0.4,0,0.5,0.2c0.1,0.2,0.3,0.5,0.5,0.8c0.7,0.8,1.6,1.3,2.7,1.4c0,0,0,0,0,0c1.2,0,2.7-0.9,4.7-2.5
            c1.5-1.3,2.7-2.6,2.7-2.6c0.1-0.2,0.4-0.2,0.6,0c0.2,0.1,0.2,0.4,0,0.6c0,0-1.2,1.3-2.8,2.6C29.5,18.9,27.8,19.8,26.5,19.8z"/>
    </g>
    <g>
        <path class="st0" d="M31.4,21.5c-1,0-2-0.5-2.8-1.3c-0.4-0.4-0.6-0.8-0.7-1.1c-0.1-0.2,0-0.4,0.2-0.5c0.2-0.1,0.4,0,0.5,0.2
            c0,0.1,0.1,0.3,0.6,0.8c0.7,0.8,1.5,1.1,2.4,1.1c0.9-0.1,2.2-1,3.9-2.8c1.3-1.3,2.3-2.6,2.3-2.6c0.1-0.2,0.4-0.2,0.6-0.1
            c0.2,0.1,0.2,0.4,0.1,0.6c0,0-1,1.3-2.4,2.7c-1.9,2-3.3,2.9-4.4,3C31.6,21.5,31.5,21.5,31.4,21.5z"/>
    </g>
    <g>
        <path class="st0" d="M36,22.8c-0.9,0-1.7-0.3-2.3-0.8c-0.9-0.8-1-1.3-0.9-1.5c0-0.2,0.2-0.4,0.4-0.4c0.3,0,0.4,0.2,0.4,0.4l-0.4,0
            l0.4,0.1c0,0,0,0.2,0.7,0.8c0.5,0.5,1.2,0.7,2,0.6c1.1-0.1,2.4-0.9,3.6-2.5c0.9-1.2,1.6-2.3,1.6-2.3c0.1-0.2,0.3-0.3,0.5-0.2
            c0.2,0.1,0.3,0.3,0.2,0.5c0,0-0.6,1.2-1.6,2.4c-1.4,1.7-2.8,2.7-4.2,2.8C36.2,22.8,36.1,22.8,36,22.8z"/>
    </g>
    <g>
        <path class="st0" d="M70.6,14.6c-4.4,0-11.8-4-12.1-4.2c-0.2-0.1-0.3-0.3-0.2-0.5c0.1-0.2,0.3-0.3,0.5-0.2c0.3,0.2,8.4,4.6,12.4,4
            c2.9-0.4,5.8-3.6,5.8-3.7c0.1-0.2,0.4-0.2,0.6,0c0.2,0.1,0.2,0.4,0,0.6c-0.1,0.1-3.1,3.5-6.3,3.9C71.2,14.6,70.9,14.6,70.6,14.6z"
            />
    </g>
    <g>
        <path class="st0" d="M65.3,17.7c-1.5,0-3.6-0.9-6.1-2.6c-1.8-1.2-3.1-2.3-3.3-2.5c-0.2-0.1-0.2-0.4,0-0.6c0.1-0.2,0.4-0.2,0.6,0
            c0.2,0.1,1.5,1.3,3.2,2.4c2.4,1.6,4.3,2.4,5.7,2.4c1.2,0,2.4-0.6,3.4-1.6c0.7-0.7,1-1.2,1-1.3l0.7,0.4l-0.4-0.2l0.4,0.2
            c-0.1,0.2-0.4,0.8-1.2,1.5C68.2,17.1,66.8,17.7,65.3,17.7z"/>
    </g>
    <g>
        <path class="st0" d="M59.9,19.8c-1.3,0-3-0.9-5.1-2.7c-1.6-1.3-2.8-2.6-2.8-2.6c-0.1-0.2-0.1-0.4,0-0.6c0.2-0.1,0.4-0.1,0.6,0
            c0,0,1.2,1.3,2.7,2.6c2,1.7,3.5,2.5,4.6,2.5c1.2,0,2.1-0.5,2.8-1.4c0.2-0.3,0.5-0.6,0.5-0.7l0.8,0.2L63.6,17l0.4,0.1
            c0,0.2-0.1,0.4-0.7,1c-0.8,1-2,1.6-3.3,1.6L59.9,19.8z"/>
    </g>
    <g>
        <path class="st0" d="M55,21.5c-0.1,0-0.2,0-0.3,0c-1.1-0.1-2.5-1.1-4.4-3C49,17.2,48,16,47.8,15.7c-0.1-0.2-0.1-0.4,0.1-0.6
            c0.2-0.1,0.4-0.1,0.6,0.1c0.2,0.2,1.1,1.4,2.3,2.6c1.7,1.8,3.1,2.7,3.9,2.8c0.9,0.1,1.7-0.3,2.4-1.1c0.4-0.4,0.5-0.7,0.5-0.8
            c0.1-0.2,0.3-0.3,0.5-0.2c0.2,0.1,0.3,0.3,0.2,0.5c-0.1,0.3-0.3,0.7-0.7,1.1C57,21,56,21.5,55,21.5z"/>
    </g>
    <g>
        <path class="st0" d="M50.4,22.8c-0.1,0-0.2,0-0.4,0c-1.4-0.1-2.8-1-4.2-2.8c-1-1.2-1.6-2.4-1.6-2.4c-0.1-0.2,0-0.4,0.2-0.5
            c0.2-0.1,0.4,0,0.5,0.2c0,0,0.6,1.1,1.6,2.3c1.3,1.6,2.5,2.4,3.6,2.5c0.8,0.1,1.5-0.1,2-0.6c0.7-0.6,0.7-0.8,0.7-0.8l0-0.1
            c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4c0,0.3,0,0.7-0.9,1.5C52.1,22.5,51.3,22.8,50.4,22.8z"/>
    </g>
</g>
</svg>Federal Cyber Forces</h3>
          <ul>
            <li><span>74% of federal agencies</span> security programs were deemed ‘at risk’ or ‘high risk’ </li>
            <li><span>The U.S. is only the 17th ‘Most Cyber-Secure’ Country,</span> dropping from its 5th ranking previously (Comparitech)</li>
          </ul></div>
         
        </div>
        <div className="map">

        {this.state.safari?<HandleImages name="map"/>:        <video autoplay="true" loop="true" muted="true">
<source src={map} type="video/webm" />
</video>}
              
        </div>
        <HandleImages name="mapBG"/>
        </div>
        <div className="last">

       
 <p>Now is the time to proactively train cyber operators!</p>
 

        </div>
        <div  className= "white" >
        <OnVisible  >
<div className="icon">

<svg id="bg" viewBox="-100 -100 200 200"  
   >
 
 
<path class="st0" d="M30.9,-39.5C34.4,-34,27.5,-18.8,28.4,-6.1C29.4,6.6,38.1,16.8,36.3,22C34.6,27.3,22.3,27.5,9.9,35.7C-2.5,43.9,-15.1,60.1,-20.3,57.5C-25.5,54.9,-23.2,33.5,-24.5,19.7C-25.8,6,-30.6,-0.1,-36.6,-13.5C-42.6,-26.8,-49.8,-47.3,-43.9,-52.4C-38,-57.5,-19,-47.1,-2.6,-44C13.7,-40.9,27.5,-45,30.9,-39.5Z"/>
</svg>
<svg x="0px" y="0px" width="116.5px"
     height="102.2px" viewBox="0 0 116.5 102.2" >
<polygon class="st0" points="81,53.6 81,53.6 81,53.6 "/>
<path class="st1" d="M19.9,8.3C19.6,8.2,19.3,8,18.9,8c0,0,0,0,0,0h-8.2c0,0,0,0,0,0c-0.2,0-0.4,0-0.6,0.1C9.8,8.3,9.5,8.5,9.4,8.8
    C9.2,9.1,9.1,9.4,9.1,9.7v6.9c0,0.2,0,0.5,0.1,0.7c0.1,0.3,0.3,0.6,0.6,0.7c0.3,0.2,0.6,0.3,0.9,0.3c0,0,0,0,0,0h8.2c0,0,0,0,0,0
    c0.2,0,0.4,0,0.7-0.1c0.3-0.1,0.6-0.3,0.7-0.6c0.2-0.3,0.3-0.6,0.3-0.9V9.7c0-0.2,0-0.5-0.1-0.7C20.4,8.8,20.2,8.5,19.9,8.3z
     M18.4,16.1h-7.1v-5.8h7.1V16.1z"/>
<path class="st1" d="M19.9,37.3c-0.3-0.2-0.6-0.3-0.9-0.3c0,0,0,0,0,0h-8.2c0,0,0,0,0,0c-0.2,0-0.4,0-0.7,0.1
    c-0.3,0.1-0.6,0.3-0.7,0.6c-0.2,0.3-0.3,0.6-0.3,0.9v6.9c0,0.2,0,0.5,0.1,0.7c0.1,0.3,0.3,0.6,0.6,0.7c0.3,0.2,0.6,0.3,0.9,0.3h8.2
    c0.2,0,0.5,0,0.7-0.1c0.3-0.1,0.6-0.3,0.7-0.6c0.2-0.3,0.3-0.6,0.3-0.9v-6.9c0-0.2,0-0.5-0.1-0.7C20.4,37.8,20.2,37.5,19.9,37.3z
     M18.4,45.1h-7.1v-5.8h7.1V45.1z"/>
<path class="st1" d="M113.9,1c-1-0.7-2.2-1-3.4-1H6.1C5.3,0,4.5,0.2,3.7,0.5C2.6,0.9,1.7,1.7,1,2.7c-0.7,1-1,2.2-1,3.4v56.1
    c0,0.8,0.2,1.6,0.5,2.4c0.5,1.1,1.2,2,2.2,2.7c1,0.7,2.2,1,3.4,1c0,0,0,0,0,0h7.6l0,0.5c0.1,2.9,0.3,6.1,0.8,9.1
    c0.2,1.7,0.5,3.2,0.8,4.5c0.1,0.6,0.3,1.2,0.4,1.7c0.2,0.6,0.3,1,0.5,1.3c0.2,0.4,0.4,1,0.5,1.7c0.1,0.9,0.2,2.1,0.3,3.6
    c0,0.7,0,1.3,0,2l0,1l-0.3,0.1c-0.5,0.3-1,0.7-1.3,1.1c-0.3,0.4-0.6,0.8-0.7,1.3c-0.2,0.5-0.3,1-0.3,1.5c0,0.6,0.1,1.2,0.4,1.7
    c0.3,0.8,0.9,1.5,1.6,2c0.7,0.5,1.6,0.8,2.5,0.8h18.7c0.6,0,1.2-0.1,1.7-0.4c0.8-0.3,1.5-0.9,2-1.6c0.5-0.7,0.8-1.6,0.8-2.5
    c0-0.9-0.2-1.7-0.7-2.4c-0.2-0.4-0.6-0.7-0.9-1L40,94.2l0-0.3c0-0.4,0.1-0.8,0.2-1.2c0.1-0.7,0.4-1.4,0.6-1.9
    c0.2-0.5,0.5-0.9,0.7-1.2c0.2-0.2,0.3-0.4,0.5-0.6c0.1-0.1,0.3-0.3,0.5-0.4l0.3-0.2c0.5-0.4,1.1-0.9,1.9-1.6
    c0.4-0.4,0.7-0.8,1.1-1.4c0.3-0.5,0.6-1,0.9-1.5c0.5-0.9,1-1.9,1.6-3.1c0.6-1.3,1.3-2.8,2-4.5c0.5-1.2,0.8-1.9,0.8-2L53,69
    c0-0.1,0-0.2,0-0.3l0-0.5h10.4l0,0.5c0,0.1,0,0.2,0,0.3l1.7,5.2c0.2,0.5,1.1,2.8,2.2,5.3c0.7,1.6,1.4,3,2.1,4.2
    c0.4,0.7,0.7,1.3,1.1,1.8c0.4,0.6,0.8,1,1.1,1.4c0.6,0.6,1.1,1,1.4,1.2l0.8,0.6c0.2,0.1,0.3,0.3,0.5,0.4c0.2,0.2,0.4,0.4,0.6,0.7
    c0.2,0.3,0.4,0.6,0.6,1.1c0.2,0.5,0.5,1.2,0.6,1.9c0.1,0.4,0.1,0.8,0.2,1.2l0,0.3l-0.2,0.2c-0.4,0.3-0.7,0.6-0.9,1
    c-0.5,0.7-0.7,1.6-0.7,2.4c0,0.6,0.1,1.2,0.4,1.7c0.3,0.8,0.9,1.5,1.6,2c0.7,0.5,1.6,0.8,2.5,0.8h18.7c0.6,0,1.2-0.1,1.7-0.4
    c0.8-0.3,1.5-0.9,2-1.6c0.5-0.7,0.8-1.6,0.8-2.5c0-0.5-0.1-1-0.3-1.5c-0.3-0.7-0.7-1.3-1.3-1.8c-0.2-0.2-0.5-0.4-0.8-0.6l-0.3-0.2
    l0-1.7c0-1.3,0-2.6,0.1-3.8c0.1-0.6,0.1-1.1,0.2-1.6c0.1-0.5,0.2-0.9,0.4-1.2c0.2-0.4,0.3-0.8,0.5-1.3c0.3-0.9,0.5-2,0.8-3.3
    c0.4-2,0.7-4.2,0.9-6.5c0.2-1.9,0.3-3.8,0.3-5.5l0-0.5h7.6c0,0,0,0,0,0c0.8,0,1.6-0.2,2.4-0.5c1.1-0.5,2-1.2,2.7-2.2
    c0.7-1,1-2.2,1-3.4V6.1c0-0.8-0.2-1.6-0.5-2.4C115.6,2.6,114.8,1.7,113.9,1z M39.5,98.6L39.5,98.6c-0.2,0.4-0.5,0.7-0.8,1
    c-0.4,0.2-0.8,0.4-1.2,0.4H18.8c-0.3,0-0.6-0.1-0.9-0.2c-0.4-0.2-0.7-0.4-1-0.8c-0.2-0.4-0.4-0.8-0.4-1.2c0-0.3,0-0.5,0.1-0.8
    c0.1-0.3,0.3-0.7,0.6-0.9c0.2-0.2,0.5-0.4,0.8-0.4l0.1,0l20.4,0.2l0.1,0.1c0.2,0.2,0.4,0.4,0.6,0.6c0.2,0.4,0.4,0.8,0.4,1.2
    C39.6,98.1,39.6,98.4,39.5,98.6z M49.1,73.4c-0.1,0.3-1,2.6-2.2,5.2c-0.7,1.5-1.4,2.9-2,3.9c-0.3,0.6-0.7,1.2-1,1.6
    c-0.3,0.4-0.6,0.8-0.8,1c-0.5,0.5-0.9,0.8-1.2,1l-0.8,0.6c-0.2,0.2-0.4,0.3-0.6,0.5c-0.3,0.3-0.6,0.6-0.9,1
    c-0.3,0.4-0.6,0.9-0.8,1.4c-0.3,0.7-0.6,1.5-0.8,2.4c-0.1,0.3-0.1,0.6-0.2,1l-0.1,0.5l-18.6-0.2l0-1.4c0-1.3,0-2.7-0.1-4
    c-0.1-0.7-0.2-1.3-0.3-1.9c-0.1-0.6-0.3-1.2-0.5-1.7c-0.1-0.2-0.2-0.6-0.4-1c-0.2-0.8-0.5-1.8-0.7-3.1c-0.4-1.9-0.7-4.1-0.9-6.3
    c-0.2-2.4-0.4-4.8-0.4-6.9c0-1.7,0.1-3.3,0.2-4.6l0-0.2l0.2-0.1c0.4-0.3,0.8-0.5,1.3-0.8c0.6-0.4,1.4-0.8,2.3-1.3l1-0.5l-0.9,4.6
    c-0.1,0.3,0,0.6,0.2,0.8c0.2,0.2,0.4,0.4,0.7,0.5c0.3,0.1,0.6,0,0.8-0.2c0.2-0.2,0.4-0.4,0.5-0.7l1.2-6.2l0.8-0.3
    c0.7-0.3,1.5-0.5,2.3-0.8l0.9-0.3l-1.1,5.6c-0.1,0.6,0.3,1.2,0.9,1.3c0.6,0.1,1.2-0.3,1.3-0.9l1.4-6.8l0.3-0.1
    c0.9-0.2,1.8-0.5,2.6-0.6l0.6-0.1l-0.1,8.1c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.6-0.1,0.8-0.3
    c0.2-0.2,0.3-0.5,0.3-0.8l0.1-9.2c0-0.3,0.1-0.6,0.3-0.9l6.6-10.2c0.2-0.3,0.4-0.5,0.8-0.7c0.6-0.3,1.5-0.3,2.1,0
    c0.3,0.2,0.6,0.4,0.7,0.7c0.2,0.3,0.2,0.6,0.2,0.9c0,0.3-0.1,0.6-0.3,0.9l-4.5,6.9c-0.1,0.1-0.1,0.2-0.2,0.3L40,54.5
    c-0.1,0.2-0.2,0.4-0.2,0.6l0,4.7c0.2,11.5,0.2,11.5,0.2,11.5c0,0.3,0.2,0.7,0.4,0.9c0.3,0.2,0.6,0.3,1,0.2c0.1,0,0.6-0.2,1.3-0.7
    c0.6-0.4,1.5-1.2,2.5-2.6c0.2-0.3,0.4-0.5,0.5-0.7l0.3-0.4c0.1-0.1,0.2-0.2,0.2-0.4c0.1-0.1,0.1-0.3,0.2-0.4c0-0.1,0.1-0.3,0.1-0.4
    c0-0.2,0-0.4,0-0.6l0-0.3c0-0.3,0-0.7,0-1.2c0-0.7,0.1-1.5,0.2-2.8c0.1-0.9,0.2-1.7,0.5-2.3c0.2-0.4,0.4-0.7,0.6-1
    c0.3-0.4,0.6-0.6,1-0.8c0.1-0.1,0.2-0.1,0.4-0.2l0.6-0.2l1,11L49.1,73.4z M65,56.3c-0.3,0.3-0.4,0.7-0.5,1.2L63.8,66h-11L52,57.4
    c0-0.3-0.1-0.6-0.2-0.8c-0.2-0.4-0.5-0.7-0.8-0.9c-0.4-0.3-0.9-0.4-1.5-0.3l0,0l-0.1,0c-0.5,0.1-1,0.2-1.5,0.4
    c-0.4,0.2-0.8,0.5-1.2,0.8c-0.6,0.5-1.1,1.2-1.5,2.1c-0.4,0.9-0.7,2-0.8,3.3c-0.1,1.3-0.2,2.4-0.2,3.4c0,0.3,0,0.5,0,0.7
    c0,0.2,0,0.3,0,0.4l0,0.2L43.9,67c-0.2,0.2-0.4,0.5-0.6,0.8c-0.1,0.1-0.2,0.2-0.2,0.3l-0.9,1.2L42,59.8l0-4.4l1.1-1.7h30.2l0.2,0.2
    l0.9,1.4l0,4.4l-0.1,9.6l-0.9-1.2c-0.1-0.1-0.2-0.2-0.2-0.3c-0.2-0.3-0.4-0.6-0.6-0.7l-0.4-0.5l0-0.5c0-0.3,0-0.7,0-1.3
    c0-0.7-0.1-1.6-0.2-2.8c-0.1-1.1-0.3-2.1-0.7-3c-0.2-0.6-0.5-1.1-0.9-1.6c-0.5-0.6-1.1-1.1-1.7-1.5c-0.5-0.3-1.1-0.5-1.7-0.5
    c-0.4-0.1-0.8,0-1.2,0.1C65.6,55.7,65.2,55.9,65,56.3z M99.8,97c0.1,0.2,0.1,0.5,0.1,0.8c0,0.3-0.1,0.6-0.2,0.9v0
    c-0.2,0.4-0.4,0.7-0.8,1c-0.4,0.3-0.8,0.4-1.2,0.4H79.1c-0.3,0-0.6-0.1-0.9-0.2c-0.4-0.2-0.7-0.4-1-0.8c-0.2-0.4-0.4-0.8-0.4-1.2
    c0-0.4,0.1-0.8,0.4-1.2c0.1-0.2,0.3-0.4,0.6-0.6l0.1-0.1l20.4-0.2l0.1,0c0.4,0.1,0.8,0.4,1,0.7C99.6,96.6,99.8,96.8,99.8,97z
     M99.8,77.6c-0.2,1.6-0.5,3.1-0.8,4.3c-0.1,0.6-0.3,1.1-0.4,1.6c-0.1,0.4-0.3,0.8-0.4,1.1c-0.3,0.6-0.5,1.3-0.6,2.3
    c-0.2,1.3-0.3,2.7-0.3,3.9c0,0.7,0,1.4,0,2l0,0.7l-18.6,0.2l-0.1-0.5c0-0.3-0.1-0.6-0.2-1c-0.2-0.9-0.4-1.7-0.8-2.4
    c-0.3-0.6-0.6-1.2-1-1.6c-0.2-0.3-0.5-0.6-0.8-0.9c-0.2-0.2-0.4-0.3-0.6-0.5L75,86.6c-0.5-0.4-1-0.8-1.6-1.4c-0.2-0.2-0.5-0.6-0.8-1
    c-0.3-0.4-0.6-0.9-0.9-1.4c-0.5-0.8-1-1.9-1.5-3c-0.8-1.6-1.5-3.3-1.9-4.4c-0.2-0.6-0.5-1.1-0.6-1.4l-0.2-0.5l-1.6-4.9l0-0.1l1-10.8
    l0.6,0.2c0.1,0,0.2,0.1,0.3,0.1c0.2,0.1,0.5,0.3,0.7,0.4c0.4,0.3,0.7,0.8,0.9,1.3c0.3,0.7,0.5,1.5,0.6,2.5c0.1,1.7,0.2,2.7,0.2,3.3
    l0,0.8c0,0.2,0,0.4,0,0.7c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.3,0.3l0.1,0.1
    c0.1,0.2,0.3,0.4,0.5,0.7c1,1.4,1.9,2.2,2.5,2.6c0.7,0.5,1.2,0.6,1.3,0.7c0.3,0.1,0.7,0,1-0.2c0.3-0.2,0.4-0.5,0.4-0.9l0.2-11.5
    l0-4.8c0-0.2-0.1-0.4-0.2-0.6L70.4,45c-0.2-0.3-0.3-0.6-0.3-0.9c0-0.3,0.1-0.6,0.2-0.9c0.2-0.3,0.4-0.5,0.7-0.7
    c0.6-0.4,1.5-0.4,2.1,0c0.3,0.2,0.6,0.4,0.8,0.7l7.4,10.1L81,53.6l0,0l0.4-0.3l0.4,0.6c0.2,0.3,0.5,0.7,0.7,1
    c0.1,0.1,0.2,0.3,0.2,0.3l0.1,0.3l0,7.2c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.3,0.8,0.3c0,0,0,0,0,0c0.6,0,1.1-0.5,1.1-1.1l0-7.1
    l0.7,0.2c1,0.3,2,0.6,2.9,0.8l0.3,0.1l1.1,5.8c0.1,0.6,0.7,1,1.3,0.9c0.6-0.1,1-0.7,0.9-1.3l-0.9-4.4l0.9,0.4
    c0.5,0.2,0.9,0.4,1.4,0.6l1.7,0.7l1,4.9c0.1,0.3,0.2,0.5,0.5,0.7c0.2,0.2,0.6,0.2,0.8,0.2c0.3-0.1,0.5-0.2,0.7-0.5
    c0.2-0.2,0.2-0.5,0.2-0.8l-0.6-3.2l1.2,0.7c0.3,0.2,0.5,0.3,0.7,0.5c0.2,0.1,0.3,0.2,0.4,0.3l0.3,0.2l0,0.2c0.2,1.3,0.3,2.9,0.3,4.7
    C100.6,70.3,100.3,74.1,99.8,77.6z M114.3,62.2c0,0.5-0.1,1-0.3,1.5c-0.3,0.7-0.8,1.3-1.4,1.7c-0.6,0.4-1.4,0.7-2.1,0.7h-7.6l0-0.5
    c0-1.4-0.2-2.6-0.3-3.7c0-0.2-0.1-0.3-0.1-0.4c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.3-0.3-0.4-0.4c-0.2-0.2-0.5-0.4-0.9-0.7
    c-0.5-0.3-1.1-0.7-1.8-1.1c-0.7-0.4-1.5-0.8-2.4-1.2c-0.7-0.3-2-0.8-3.2-1.4c-0.6-0.3-1.3-0.5-1.8-0.7c-0.6-0.2-1.1-0.4-1.5-0.6
    c-0.7-0.2-1.9-0.6-3.1-0.9c-0.6-0.2-1.2-0.3-1.7-0.5c-0.3-0.1-0.5-0.1-0.7-0.2c-0.1,0-0.3-0.1-0.4-0.1l-0.2,0L84,53.1
    c-0.1-0.2-0.2-0.4-0.4-0.5l-0.5-0.7l-3.3-4.5h8.6c0.3,0,0.5,0,0.7-0.1c0.3-0.1,0.6-0.3,0.7-0.6c0.2-0.3,0.3-0.6,0.3-0.9v-6.9
    c0-0.2,0-0.5-0.1-0.7c-0.1-0.3-0.3-0.6-0.6-0.7c-0.3-0.2-0.6-0.3-0.9-0.3c0,0,0,0,0,0h-8.2c-0.3,0-0.5,0-0.7,0.1
    c-0.3,0.1-0.6,0.3-0.7,0.6c-0.2,0.3-0.3,0.6-0.3,0.9v6.9l-2.7-3.7c-0.4-0.6-0.9-1.1-1.6-1.4c-1-0.5-2.3-0.6-3.4-0.3c0,0-0.1,0-0.1,0
    c-0.2,0.1-0.5,0.2-0.7,0.3c-0.6,0.4-1.2,0.9-1.5,1.5c-0.4,0.6-0.6,1.3-0.6,2c0,0.1,0,0.3,0,0.4l0.1,0.6h-4.5v-5.8H70
    c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1,0c0.4-0.2,0.7-0.6,0.7-1c0-0.6-0.5-1.1-1.1-1.1h-7.1c0,0,0,0,0,0c-0.2,0-0.4,0-0.7,0.1
    c-0.3,0.1-0.6,0.3-0.7,0.6c-0.2,0.3-0.3,0.6-0.3,0.9v6.9c0,0.2,0,0.5,0.1,0.7c0.1,0.3,0.3,0.6,0.6,0.7c0.3,0.2,0.6,0.3,0.9,0.3
    c0,0,0,0,0,0h6.3l0.2,0.2l2.6,4H44.6l3.5-5.3c0.4-0.7,0.7-1.4,0.7-2.2c0-0.7-0.2-1.4-0.6-2c-0.4-0.6-0.9-1.1-1.5-1.5
    c-1.3-0.7-3-0.8-4.3-0.1c-0.7,0.3-1.2,0.8-1.6,1.4l-2.8,4.2v-7.4c0-0.2,0-0.5-0.1-0.7c-0.1-0.3-0.3-0.6-0.6-0.7
    c-0.3-0.2-0.6-0.3-0.9-0.3c0,0,0,0,0,0h-8.2c0,0,0,0,0,0c-0.2,0-0.4,0-0.7,0.1c-0.3,0.1-0.6,0.3-0.7,0.6c-0.2,0.3-0.3,0.6-0.3,0.9
    v6.9c0,0.2,0,0.5,0.1,0.7c0.1,0.3,0.3,0.6,0.6,0.7c0.3,0.2,0.6,0.3,0.9,0.3c0,0,0,0,0,0h9.1l-3.1,4.7c-0.2,0.3-0.3,0.6-0.4,0.9
    l-0.2,0.5L33,53.3c-0.2-0.1-0.4-0.1-0.5,0c-1.2,0.2-2.5,0.6-3.9,1c-0.8,0.3-2,0.7-3.3,1.1c-0.6,0.2-1.2,0.4-1.8,0.7
    c-0.6,0.2-1,0.4-1.4,0.5c-1.7,0.8-3.5,1.7-4.9,2.5c-0.4,0.2-0.7,0.4-1.1,0.6c-0.2,0.1-0.5,0.3-0.7,0.4c-0.2,0.1-0.3,0.2-0.4,0.3
    c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.2,0.2-0.4,0.4c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.1,0.3-0.2,0.5c-0.2,1.1-0.3,2.3-0.3,3.7
    l0,0.5H6.1c-0.5,0-1-0.1-1.5-0.3c-0.7-0.3-1.3-0.8-1.7-1.4c-0.4-0.6-0.7-1.4-0.7-2.1V6.1c0-0.5,0.1-1,0.3-1.5
    c0.3-0.7,0.8-1.3,1.4-1.7c0.6-0.4,1.4-0.7,2.1-0.7h104.4c0.5,0,1,0.1,1.5,0.3c0.7,0.3,1.3,0.8,1.7,1.4c0.4,0.6,0.7,1.4,0.7,2.1V62.2
    z M80.8,45.1v-5.8h7.1v5.8H80.8z M35.7,39.3v5.8h-7.1v-5.8H35.7z"/>
<path class="st1" d="M49.4,55.4L49.4,55.4L49.4,55.4C49.4,55.4,49.4,55.4,49.4,55.4C49.4,55.4,49.4,55.4,49.4,55.4z"/>
<path class="st1" d="M19.9,22.8c-0.3-0.2-0.6-0.3-0.9-0.3h-8.2c-0.2,0-0.5,0-0.7,0.1c-0.3,0.1-0.6,0.3-0.7,0.6
    c-0.2,0.3-0.3,0.6-0.3,0.9v6.9c0,0.2,0,0.5,0.1,0.7c0.1,0.3,0.3,0.6,0.6,0.7c0.3,0.2,0.6,0.3,0.9,0.3h8.2c0.2,0,0.5,0,0.7-0.1
    c0.3-0.1,0.6-0.3,0.7-0.6c0.2-0.3,0.3-0.6,0.3-0.9v-6.9c0-0.2,0-0.5-0.1-0.7C20.4,23.3,20.2,23,19.9,22.8z M18.4,30.6h-7.1v-5.8h7.1
    V30.6z"/>
<path class="st1" d="M106.7,37.3L106.7,37.3c-0.3-0.2-0.6-0.3-0.9-0.3c0,0,0,0,0,0h-8.2c0,0,0,0,0,0c-0.2,0-0.4,0-0.7,0.1
    c-0.3,0.1-0.6,0.3-0.7,0.6c-0.2,0.3-0.3,0.6-0.3,0.9v6.9c0,0.2,0,0.5,0.1,0.7c0.1,0.3,0.3,0.6,0.6,0.7c0.3,0.2,0.6,0.3,0.9,0.3
    c0,0,0,0,0,0h8.2c0.2,0,0.5,0,0.7-0.1c0.3-0.1,0.6-0.3,0.7-0.6c0.2-0.3,0.3-0.6,0.3-0.9v-6.9c0-0.2,0-0.5-0.1-0.7
    C107.2,37.8,107,37.5,106.7,37.3z M105.2,45.1h-7.1v-5.8h7.1V45.1z"/>
<path class="st1" d="M89.4,8.3L89.4,8.3C89.1,8.2,88.8,8,88.4,8c0,0,0,0,0,0h-8.2c0,0,0,0,0,0c-0.2,0-0.4,0-0.7,0.1
    c-0.3,0.1-0.6,0.3-0.7,0.6c-0.2,0.3-0.3,0.6-0.3,0.9v6.9c0,0.2,0,0.4,0.1,0.7c0.1,0.3,0.3,0.6,0.6,0.7c0.3,0.2,0.6,0.3,0.9,0.3
    c0,0,0,0,0,0h8.2c0,0,0,0,0,0c0.2,0,0.4,0,0.7-0.1c0.3-0.1,0.6-0.3,0.7-0.6c0.2-0.3,0.3-0.6,0.3-0.9V9.7c0-0.2,0-0.5-0.1-0.7
    C89.8,8.8,89.6,8.5,89.4,8.3z M87.9,16.1h-7.1v-5.8h7.1V16.1z"/>
<path class="st1" d="M106.7,22.8c-0.3-0.2-0.6-0.3-0.9-0.3h-8.2c-0.2,0-0.5,0-0.7,0.1c-0.3,0.1-0.6,0.3-0.7,0.6
    c-0.2,0.3-0.3,0.6-0.3,0.9v6.9c0,0.2,0,0.5,0.1,0.7c0.1,0.3,0.3,0.6,0.6,0.7c0.3,0.2,0.6,0.3,0.9,0.3h8.2c0.2,0,0.5,0,0.7-0.1
    c0.3-0.1,0.6-0.3,0.7-0.6c0.2-0.3,0.3-0.6,0.3-0.9v-6.9c0-0.2,0-0.5-0.1-0.7C107.2,23.3,107,23,106.7,22.8z M105.2,30.6h-7.1v-5.8
    h7.1V30.6z"/>
<path class="st1" d="M106.7,8.3c-0.3-0.2-0.6-0.3-0.9-0.3c0,0,0,0,0,0h-8.2c0,0,0,0,0,0c-0.2,0-0.4,0-0.6,0.1
    c-0.3,0.1-0.6,0.3-0.7,0.6c-0.2,0.3-0.3,0.6-0.3,0.9v6.9c0,0.2,0,0.5,0.1,0.7c0.1,0.3,0.3,0.6,0.6,0.7c0.3,0.2,0.6,0.3,0.9,0.3
    c0,0,0,0,0,0h8.2c0,0,0,0,0,0c0.2,0,0.4,0,0.7-0.1c0.3-0.1,0.6-0.3,0.7-0.6c0.2-0.3,0.3-0.6,0.3-0.9V9.7c0-0.2,0-0.5-0.1-0.7
    C107.2,8.8,107,8.5,106.7,8.3z M105.2,16.1h-7.1v-5.8h7.1V16.1z"/>
<path class="st1" d="M89.4,22.8L89.4,22.8c-0.3-0.2-0.6-0.3-0.9-0.3h-8.2c-0.2,0-0.5,0-0.7,0.1c-0.3,0.1-0.6,0.3-0.7,0.6
    c-0.2,0.3-0.3,0.6-0.3,0.9v6.9c0,0.2,0,0.4,0.1,0.7c0.1,0.3,0.3,0.6,0.6,0.7c0.3,0.2,0.6,0.3,0.9,0.3h8.2c0.2,0,0.5,0,0.7-0.1
    c0.3-0.1,0.6-0.3,0.7-0.6c0.2-0.3,0.3-0.6,0.3-0.9v-6.9c0-0.2,0-0.5-0.1-0.7C89.8,23.3,89.6,23,89.4,22.8z M87.9,30.6h-7.1v-5.8h7.1
    V30.6z"/>
<path class="st1" d="M37.3,8.3L37.3,8.3C37,8.2,36.6,8,36.3,8c0,0,0,0,0,0h-8.2c0,0,0,0,0,0c-0.2,0-0.4,0-0.7,0.1
    c-0.3,0.1-0.6,0.3-0.7,0.6c-0.2,0.3-0.3,0.6-0.3,0.9v6.9c0,0.2,0,0.4,0.1,0.7c0.1,0.3,0.3,0.6,0.6,0.7c0.3,0.2,0.6,0.3,0.9,0.3
    c0,0,0,0,0,0h8.2c0,0,0,0,0,0c0.2,0,0.4,0,0.7-0.1c0.3-0.1,0.6-0.3,0.7-0.6c0.2-0.3,0.3-0.6,0.3-0.9V9.7c0-0.2,0-0.5-0.1-0.7
    C37.7,8.8,37.5,8.5,37.3,8.3z M35.8,16.1h-7.1v-5.8h7.1V16.1z"/>
<path class="st1" d="M54.6,22.8c-0.3-0.2-0.6-0.3-0.9-0.3h-8.2c-0.2,0-0.5,0-0.7,0.1c-0.3,0.1-0.6,0.3-0.7,0.6
    c-0.2,0.3-0.3,0.6-0.3,0.9v6.9c0,0.2,0,0.5,0.1,0.7c0.1,0.3,0.3,0.6,0.6,0.7c0.3,0.2,0.6,0.3,0.9,0.3h8.2c0.2,0,0.5,0,0.7-0.1
    c0.3-0.1,0.6-0.3,0.7-0.6c0.2-0.3,0.3-0.6,0.3-0.9v-6.9c0-0.2,0-0.5-0.1-0.7C55.1,23.3,54.9,23,54.6,22.8z M53.1,30.6H46v-5.8h7.1
    V30.6z"/>
<path class="st1" d="M37.3,22.8L37.3,22.8c-0.3-0.2-0.6-0.3-0.9-0.3h-8.2c-0.2,0-0.5,0-0.7,0.1c-0.3,0.1-0.6,0.3-0.7,0.6
    c-0.2,0.3-0.3,0.6-0.3,0.9v6.9c0,0.2,0,0.5,0.1,0.7c0.1,0.3,0.3,0.6,0.6,0.7c0.3,0.2,0.6,0.3,0.9,0.3h8.2c0.2,0,0.5,0,0.7-0.1
    c0.3-0.1,0.6-0.3,0.7-0.6c0.2-0.3,0.3-0.6,0.3-0.9v-6.9c0-0.2,0-0.5-0.1-0.7C37.7,23.3,37.5,23,37.3,22.8z M35.8,30.6h-7.1v-5.8h7.1
    V30.6z"/>
<path class="st1" d="M72,22.8c-0.3-0.2-0.6-0.3-0.9-0.3h-8.2c-0.2,0-0.5,0-0.7,0.1c-0.3,0.1-0.6,0.3-0.7,0.6
    c-0.2,0.3-0.3,0.6-0.3,0.9v6.9c0,0.2,0,0.5,0.1,0.7c0.1,0.3,0.3,0.6,0.6,0.7c0.3,0.2,0.6,0.3,0.9,0.3H71c0.2,0,0.5,0,0.7-0.1
    c0.3-0.1,0.6-0.3,0.7-0.6c0.2-0.3,0.3-0.6,0.3-0.9v-6.9c0-0.2,0-0.5-0.1-0.7C72.5,23.3,72.3,23,72,22.8z M70.5,30.6h-7.1v-5.8h7.1
    V30.6z"/>
<path class="st1" d="M54.6,8.3C54.3,8.2,54,8,53.7,8c0,0,0,0,0,0h-8.2c0,0,0,0,0,0c-0.2,0-0.4,0-0.6,0.1c-0.3,0.1-0.6,0.3-0.7,0.6
    c-0.2,0.3-0.3,0.6-0.3,0.9v6.9c0,0.2,0,0.5,0.1,0.7c0.1,0.3,0.3,0.6,0.6,0.7c0.3,0.2,0.6,0.3,0.9,0.3c0,0,0,0,0,0h8.2c0,0,0,0,0,0
    c0.2,0,0.4,0,0.7-0.1c0.3-0.1,0.6-0.3,0.7-0.6c0.2-0.3,0.3-0.6,0.3-0.9V9.7c0-0.2,0-0.5-0.1-0.7C55.1,8.8,54.9,8.5,54.6,8.3z
     M53.1,16.1H46v-5.8h7.1V16.1z"/>
<path class="st1" d="M72,8.3C71.7,8.2,71.4,8,71.1,8c0,0,0,0,0,0h-8.2c0,0,0,0,0,0c-0.2,0-0.4,0-0.6,0.1c-0.3,0.1-0.6,0.3-0.7,0.6
    c-0.2,0.3-0.3,0.6-0.3,0.9v6.9c0,0.2,0,0.5,0.1,0.7c0.1,0.3,0.3,0.6,0.6,0.7c0.3,0.2,0.6,0.3,0.9,0.3c0,0,0,0,0,0H71c0,0,0,0,0,0
    c0.2,0,0.4,0,0.7-0.1c0.3-0.1,0.6-0.3,0.7-0.6c0.2-0.3,0.3-0.6,0.3-0.9V9.7c0-0.2,0-0.5-0.1-0.7C72.5,8.8,72.3,8.5,72,8.3z
     M70.5,16.1h-7.1v-5.8h7.1V16.1z"/>
</svg>
</div>
<span> <strong>A hands-on learning platform</strong> that uses cyber range-as-a-service-technology to deliver Virtual-Machine-based training excersises to augment cyber security readiness.</span>
</OnVisible>
<OnVisible  >
<div className="icon">
<svg id="bg" viewBox="-100 -100 200 200"  
   >
 
 
<path class="st0" d="M30.9,-39.5C34.4,-34,27.5,-18.8,28.4,-6.1C29.4,6.6,38.1,16.8,36.3,22C34.6,27.3,22.3,27.5,9.9,35.7C-2.5,43.9,-15.1,60.1,-20.3,57.5C-25.5,54.9,-23.2,33.5,-24.5,19.7C-25.8,6,-30.6,-0.1,-36.6,-13.5C-42.6,-26.8,-49.8,-47.3,-43.9,-52.4C-38,-57.5,-19,-47.1,-2.6,-44C13.7,-40.9,27.5,-45,30.9,-39.5Z"/>
</svg>


<svg x="0px" y="0px" width="98.7px"
     height="102.3px" viewBox="0 0 98.7 102.3" >
<g>
    <g>
        <path class="st0" d="M12.2,101.8v-1.6c3.1,0,6.2-1.1,8.5-3.2l4.7-3.8c3.3-2.6,7.6-3.9,11.8-3.3c2.9,0.4,5.9,0.5,8.9,0.5
            c12.1,0,30.1-3,47.3-17.1c5.1-4.2,2.8-11.5-0.1-18c-4.2-9.6-13.1-24.2-25-43.2c-1.6-2.5-3.8-4.4-6.4-5.5c-7.2-3-12.8-4.4-18.3-4.6
            C41.4,2,39,3.2,37,5.4c-1.9,2.1-4.4,8.4-5.3,13.1c-0.5,3,0.6,4.8,1.7,5.8c3.1,2.8,9.8,2.8,20.6,0l0.5-0.1l0.3,0.4
            c4.1,5.5,4.6,11,5.3,16.7c0.3,2.5,0.5,5,1.1,7.6l0.3,1.5l-1.4-0.6c-6.6-2.9-12.3-2.1-15.9-1C41.3,49.6,39,51,37.5,52l-0.6,0.5
            l-0.5-0.6c-2.5-3.5-6.1-6.1-10.2-7.4c-4.4-1.4-9.3-1.4-13.8,0.1C9.9,45.3,7.8,45.2,6,44c-1.4-0.9-3.1-1-4.6-0.2l-0.8-1.4
            c2-1.1,4.4-1,6.2,0.2c1.3,0.9,2.9,1,5,0.3c4.8-1.6,10-1.6,14.8-0.1c4.2,1.3,7.9,3.9,10.6,7.4c1.5-1,3.8-2.2,6.5-3.1
            c3.6-1.1,9.2-1.9,15.6,0.5c-0.4-2.1-0.6-4.2-0.8-6.3C58,36,57.4,30.9,53.9,25.9c-11.1,2.9-18,2.8-21.5-0.5
            c-1.4-1.2-2.9-3.5-2.2-7.2c0.9-5,3.6-11.5,5.7-13.8c2.3-2.6,5.1-3.9,8-3.8c5.7,0.2,11.5,1.6,18.9,4.7c2.9,1.2,5.4,3.3,7.1,6.1
            c12,19,20.9,33.7,25.1,43.4c3.1,7.1,5.5,15.1-0.4,19.9C77,89,58.6,92,46.2,92c-3.1,0-6.1-0.2-9.1-0.6c-3.8-0.5-7.7,0.6-10.6,3
            l-4.7,3.7C19.1,100.5,15.7,101.8,12.2,101.8z"/>
    </g>
    <g>
        <path class="st0" d="M53.5,79.1c-6.2,0-12.3-1.7-17.6-4.9l0.8-1.4c5,3,10.8,4.6,16.7,4.6c7.2,0,14-2.3,19.6-6.6l1,1.3
            C68.1,76.7,61,79.1,53.5,79.1z"/>
    </g>
</g>
</svg>



 

</div>
<span>  Teams <strong>demonstrate cyber "fitness"</strong> anytime, anywhere, to show performance improvement. So when a crisis hits, they can respond efficiently.</span>
</OnVisible  >
   <OnVisible  >
<div className="icon">
<svg id="bg" viewBox="-100 -100 200 200"  
   >
 
 
<path class="st0" d="M30.9,-39.5C34.4,-34,27.5,-18.8,28.4,-6.1C29.4,6.6,38.1,16.8,36.3,22C34.6,27.3,22.3,27.5,9.9,35.7C-2.5,43.9,-15.1,60.1,-20.3,57.5C-25.5,54.9,-23.2,33.5,-24.5,19.7C-25.8,6,-30.6,-0.1,-36.6,-13.5C-42.6,-26.8,-49.8,-47.3,-43.9,-52.4C-38,-57.5,-19,-47.1,-2.6,-44C13.7,-40.9,27.5,-45,30.9,-39.5Z"/>
</svg>
<svg x="0px" y="0px" width="104.8px"
     height="109.1px" viewBox="0 0 104.8 109.1" >
<g>
    <g>
        <path class="st0" d="M89.1,109.1H41.3c-3.9,0-7.6-1.4-10.5-4c-0.5-0.5-0.6-1.3-0.1-1.8c0.5-0.5,1.3-0.6,1.8-0.1
            c2.4,2.2,5.5,3.4,8.8,3.4h47.8c7.3,0,13.2-5.9,13.2-13.2V60.1c0-7.3-5.9-13.2-13.2-13.2H41.3c-3.2,0-6.4,1.2-8.8,3.4
            c-0.5,0.5-1.3,0.4-1.8-0.1c-0.5-0.5-0.4-1.3,0.1-1.8c2.9-2.6,6.6-4,10.5-4h47.8c8.6,0,15.7,7,15.7,15.7v33.3
            C104.8,102,97.7,109.1,89.1,109.1z"/>
    </g>
    <g>
        <g>
            <path class="st0" d="M93.7,46.2h-2.5V28.5c0-14.3-11.7-26-26-26c-14.3,0-26,11.7-26,26v17.7h-2.5V28.5C36.7,12.8,49.5,0,65.2,0
                s28.5,12.8,28.5,28.5V46.2z M83.3,46.2h-2.5V28.5c0-8.6-7-15.6-15.6-15.6s-15.6,7-15.6,15.6v17.7h-2.5V28.5
                c0-10,8.1-18.1,18.1-18.1c10,0,18.1,8.1,18.1,18.1V46.2z"/>
        </g>
    </g>
    <g>
        <path class="st0" d="M65.2,92.9c-0.7,0-1.2-0.6-1.2-1.2V61.8c0-0.7,0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2v29.8
            C66.4,92.3,65.9,92.9,65.2,92.9z"/>
    </g>
    <g>
        <path class="st0" d="M23.9,100.6C10.7,100.6,0,89.9,0,76.7s10.7-23.9,23.9-23.9c8.4,0,16.2,4.4,20.5,11.6h21.3V67H42.9l-0.4-0.6
            c-3.8-6.8-10.9-11-18.7-11C12.1,55.4,2.5,65,2.5,76.7s9.6,21.4,21.4,21.4c7.7,0,14.9-4.2,18.7-11l0.4-0.6h22.7v2.5H44.3
            C40,96.1,32.3,100.6,23.9,100.6z"/>
    </g>
    <g>
        <path class="st0" d="M15.6,83.5c-3.8,0-6.8-3.1-6.8-6.8c0-3.8,3.1-6.8,6.8-6.8c3.8,0,6.8,3.1,6.8,6.8
            C22.4,80.5,19.3,83.5,15.6,83.5z M15.6,72.4c-2.4,0-4.3,1.9-4.3,4.3s1.9,4.3,4.3,4.3s4.3-1.9,4.3-4.3S17.9,72.4,15.6,72.4z"/>
    </g>
</g>
</svg>
</div>
<span> <strong>Cyber preparedness</strong> is the  lock and <strong>consistent training</strong> is the key</span>
</OnVisible  >

</div>
      </div>
    )
  }
}

export default GovInfo
